// extracted by mini-css-extract-plugin
export var navbar = "Navbar-module--navbar--2iwn6";
export var container = "Navbar-module--container--LjYDj";
export var logo = "Navbar-module--logo--3pKax";